/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetAvailableCoursesOptions, GetAvailableCoursesResponses } from '../../models/GetAvailableCourses'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description List all available courses for this org.
 * @summary Get Available Courses
 * {@link /courses/available}
 */
export function getAvailableCourses<ThrowOnError extends boolean = true>(options: Options<GetAvailableCoursesOptions, ThrowOnError> = {}): Promise<UnwrappedResult<GetAvailableCoursesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/courses/available', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetAvailableCoursesResponses, ThrowOnError>>
}
